(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('paymentHistoryCtrl',
    ['$scope',
      '$http',
      'uteEndpoint',
      'uteLocale',
      '$rootScope',
      '$stateParams',
      'commonService',
      '$state',
      'env',
      function ($scope, $http, uteEndpoint, uteLocale, $rootScope, $stateParams, commonService, $state, env) {
        var self = {};
        $scope.payment = {};
        $scope.paymentHistoryStatus = 'LOADING';
        $scope.paymentHistorySection = true;
        $scope.language = uteLocale.language;
        $scope.isSubscriber = false;
        if ($rootScope.userInfo.profileType.subscriber != null && $rootScope.userInfo.profileType.subscriber != '') {
          $scope.isSubscriber = $rootScope.userInfo.profileType.subscriber;
        }

        if ($stateParams.accountNumber) {
          $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
          $rootScope.userInfo.selectedSubscriberNo = '';
        } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber)) {
          $state.go('myAccount.overview');
        } else {
          if (!$stateParams.accountNumber) {
            $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
          }
        }


        $scope.accountNumber = $stateParams.accountNumber;
        $scope.selectedAccountNumber = $stateParams.accountNumber;

        $scope.accountSelected = function (acc) {
          $state.go('myAccount.paymentHistory', {
            'accountNumber': acc
          });
        };

        function displayPaymentDate(account) {
          return (account && Number(account.balance) > 0 && (account.paymentDueDate && account.paymentDueDate !== 'null') && account.MOPType === 'invoice');
        }

        function convertToDateObj(dateString) {
          var splitText = dateString.split('/');
          var day = splitText[0];
          var month = splitText[1] - 1;
          var year = splitText[2];
          return new Date(year, month, day);
        }

        self.loadPaymentDetail = function () {
          var selectedAccountDetail;

          console.log('$scope.selectedAccountNumber', $scope.selectedAccountNumber);

          if ($scope.selectedAccountNumber) {
            selectedAccountDetail = _.find(commonService.accountDetails, function (accountDetail) {
              return accountDetail.accountNumber === $scope.selectedAccountNumber;
            });
          }
          $scope.payment = {};

          if (selectedAccountDetail) {
            $scope.payment = {
              accountBalance: selectedAccountDetail.balance,
              date: selectedAccountDetail.paymentDueDate,
              hasWireless: selectedAccountDetail.hasWireless,
              MOPType: selectedAccountDetail.MOPType,
              displayPaymentDate: displayPaymentDate(selectedAccountDetail)
            };
          }
        };

        $scope.filterWirelessCFA = function (account) {
          return ($rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless');
        };

        $scope.filterFraud = function (account) {
          var selectedAccountDetail = _.find(commonService.accountDetails, function (accountDetail) {
            return accountDetail.accountNumber === account.accountNumber;
          });

          return (selectedAccountDetail.fraud !== true);
        };

        self.loadPaymentDetail();

        if (!$scope.payment.hasWireless && _.isEmpty($scope.payment.MOPType)) {
          //alert("not wireless");
          $http({
            method: 'POST',
            url: uteEndpoint('v1/billingArrangementData'),
            data: {billingArrangementId: $scope.selectedAccountNumber}
          }).success(function (data) {
            $scope.payment.MOPType = data.methodOfPayment;
          });
        }


        self.loadPaymentHistory = function () {
          if ($scope.payment.hasWireless) {
            $scope.showWirelessHistory = true;
            $scope.showInternetHistory = false;
            $scope.labelName = 'global.label.wireless';
          } else {
            $scope.showWirelessHistory = false;
            $scope.showInternetHistory = true;
            if (commonService.customerHasTV) {
              $scope.labelName = 'Internet/TV';
            } else {
              $scope.labelName = 'global.label.internet';
            }
          }
          $http({
            method: 'POST',
            url: uteEndpoint('v2/paymentHistory'),
            data: {
              accountNumber: $scope.selectedAccountNumber
            }
          }).success(function (data) {
            if (data && data.getPaymentHistory && data.getPaymentHistory.error) {
              console.log('error');
              $scope.paymentHistoryStatus = 'ERROR';
            } else if (data && data.getPaymentHistory && data.getPaymentHistory.en && data.getPaymentHistory.en.records && (!(_.isEmpty(data.getPaymentHistory.en.records)))) {
              if ($scope.payment.hasWireless) {
                var paymentStatusUrl = env.name === 'local' ? 'resource/paymentstatuses.json' : 'cms/ute/fido/resource/paymentstatuses.json?20181111';
                $http.get(paymentStatusUrl).then(function(response) {
                  if (response && response.data && response.data.STATUS) {
                    var paymentHistoryWireless = data.getPaymentHistory.en.records;
                    $.each(paymentHistoryWireless, function (key, value) {
                      value.paymentDate = convertToDateObj(value.paymentDate);
                      value.absolutePaymentAmount = value.paymentAmount;
                      if(value.status === 'BCK' || value.status === 'FNTF') {
                        value.paymentAmount *= -1;
                      }
                    });
                    $scope.paymentHistoryWireless = _.filter(paymentHistoryWireless, function (value) {
                      return !!_.find(response.data.STATUS, {CODE: value.status});
                    });
                  } else {
                    $scope.paymentHistoryStatus = 'EMPTY';
                    $scope.showWirelessHistory = false;
                    $scope.showInternetHistory = false;
                  }
                });
              } else {
                $scope.paymentHistory = _.map(data.getPaymentHistory.en.records, function (record) {
                  return angular.extend(record, {
                    sortFieldPaymentMethod: (record.paymentMethod + ' ' + record.creditCardType),
                    absolutePaymentAmount: record.paymentAmount,
                    paymentDate: convertToDateObj(record.paymentDate),
                    paymentAmount: (record.status === 'RFNDR' || record.status === 'FTF' || record.status === 'BCK') ? record.paymentAmount *-1 : record.paymentAmount
                  });
                });
              }
              $scope.paymentHistoryStatus = 'SUCCESS';
            }
            else {
              $scope.paymentHistoryStatus = 'EMPTY';
              $scope.showWirelessHistory = false;
              $scope.showInternetHistory = false;
              console.log('no data');
            }
          }).error(function (data) {
            console.log('error');
            $scope.paymentHistoryStatus = 'ERROR';
          });
        };

        self.loadPaymentHistory();
        // TODO: Modularize
        self.init = function () {
          if ($rootScope.userInfo && ($rootScope.userInfo.accounts || []).length > 0) {
            if ($stateParams.accountNumber) {
              $scope.selectedAccountNumber = $stateParams.accountNumber;
            } else {
              $scope.selectedAccountNumber = $rootScope.userInfo.accounts[0].accountNumber;
            }

            // self.loadPaymentDetails();
          }

        };

        /*self.loadPaymentDetails = function(){
          commonService.loadPaymentDetails($rootScope.userInfo.accounts).then(function(){
            $scope.accountSelected($scope.selectedAccountNumber);
          }, function(){
            $scope.accountSelected($scope.selectedAccountNumber);
          });
        };*/

        $scope.payNow = function () {
          $state.go('myAccount.payNow', {
            'accountNumber': $stateParams.accountNumber
          });
        };

        $scope.viewBill = function () {
          $state.go('myAccount.viewInvoice', {
            'accountNumber': $stateParams.accountNumber
          });
        };

        self.init();
      }]);

})();
